import styled from '@emotion/styled';

import { SwitchElementProps } from './types';

export const SwitchElement = styled.div<SwitchElementProps>`
  font-family: ${({ theme }) => theme.switch.general.font_family};
  font-size: ${({ theme }) => theme.switch.general.font_size};
  color: ${({ theme }) => theme.field.color.normal};

  &:hover {
    color: ${({ theme }) => theme.field.color.hover};
  }

  button {
    background: ${({ theme }) => theme.switch.background.normal};
    border: ${({ theme }) => theme.field.border.normal};
    color: ${({ theme }) => theme.field.color.normal};
  }

  &:hover button {
    background: ${({ theme }) => theme.switch.background.hover};
    border: ${({ theme }) => theme.field.border.hover};
    color: ${({ theme }) => theme.field.color.normal};
  }

  /* active state */
  &[aria-checked='true'] button {
    background: ${({ theme }) => theme.switch.background.active};
    border: ${({ theme }) => theme.field.border.active};
    color: ${({ theme }) => theme.field.color.normal};
  }

  /* disabled state */
  &[data-disabled='true'] button {
    background: ${({ theme }) => theme.switch.background.disabled};
    border: ${({ theme }) => theme.field.border.disabled};
    color: ${({ theme }) => theme.field.color.disabled};
    pointer-events: none;
    opacity: 0.6;
  }
`;
